type Props = {
  className: string;
};

// Selected-state check badge shared by swatches and option buttons.
//
// Inlined rather than loaded from `/icons`, so it never makes a network
// request: the widget runs on third-party pages where the asset base URL or a
// strict CSP could otherwise break it.
export function CheckBadge(props: Props) {
  return (
    <svg
      className={props.className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle
        className="check-badge__disc"
        cx="11.5"
        cy="12.5"
        r="7.5"
        fill="black"
      />
      <path
        className="check-badge__tick"
        d="M10.5385 13.35C9.81853 12.678 8.66654 10.79 7.51454 11.382C7.21054 11.526 7.05053 11.798 7.01853 12.182C6.97053 12.678 7.01854 12.998 7.13054 13.142C8.18654 14.454 9.08253 15.494 9.83453 16.294C10.1705 16.646 10.7465 16.662 11.0825 16.31L15.2425 12.15C15.7065 11.686 15.7225 10.934 15.2745 10.47L15.1625 10.358C14.7145 9.87802 13.9305 9.87802 13.4985 10.374L10.8585 13.35C10.7785 13.446 10.6345 13.446 10.5385 13.35Z"
        fill="#F4F6FC"
      />
    </svg>
  );
}
